import { type ReactNode } from "react";

interface PanelProps {
	children: ReactNode;
	title?: string;
}

export function Panel({ children, title }: PanelProps) {
	return (
		<div className="ais-panel" title={title}>
			<div className="ais-panel__body">{children}</div>
		</div>
	);
}
